import { useThemeContext } from '#contexts/ThemeContext';
import { Box } from '@material-ui/core';
import React, { ReactElement } from 'react';
import { Footer } from './Footer';
import { Header } from './Header';

export interface LayoutProps {
  children: JSX.Element;
  disabled?: boolean;
  handleBack?: () => void;
  isWhiteLabel?: boolean;
  showBackButton?: boolean;
}
export type Layout = (props: LayoutProps) => ReactElement;

export const MainLayout: Layout = ({
  children,
  disabled = true,
  handleBack = () => null,
  isWhiteLabel = false,
  showBackButton = false
}: LayoutProps): ReactElement => {
  const { background, isEmbed, hideHeader } = useThemeContext();
  return (
    <React.Fragment>
      <Box
        style={{ backgroundColor: background }}
        display='flex'
        flexDirection='column'
        minHeight={isEmbed ? '92%' : '100%'}
        width='100%'
        overflow='auto'
        justifyContent='center'
        alignItems='center'
        mx='auto'
      >
        {!(isEmbed && hideHeader) && <Header />}
        <Box
          flexGrow={1}
          minHeight={isEmbed ? '82%' : 'calc(92% - 100px)'}
          display='flex'
          margin='auto'
          width='100%'
          justifyContent='center'
        >
          {children}
        </Box>
        {!isEmbed && <Footer isWhiteLabel={isWhiteLabel} showBackButton={showBackButton} />}
      </Box>
      {isEmbed && (
        <Footer
          disabled={disabled}
          handleBack={handleBack}
          isWhiteLabel={isWhiteLabel}
          showBackButton={showBackButton}
        />
      )}
    </React.Fragment>
  );
};
